import axios from "axios";
import config from "../config";

const https = require('https');

const agent = new https.Agent({
    rejectUnauthorized: false,
});

const instance = axios.create({
    baseURL: config.WS_BASE_URL,
});

instance.interceptors.request.use(async(config) => {
    config.httpsAgent = agent
    const token = localStorage.getItem("token");
    config.headers.Authorization = token ? token : "";
    config.headers.ContentType = "application/json";
    return config;
});

export const merchShop = async(formData) =>
    await instance.post("merch/product/new", formData );

export const allProds = async() =>
    await instance.post("merch/product/all" );

export const addStockById = async(id,qt) =>
    await instance.post("merch/product/addstock", {id,qt} );

export const getProdByID = async(id) =>
    await instance.post("merch/product/byid", {id} );

export const deleteProdID = async(id) =>
    await instance.post("merch/product/delete", {id} );

export const merchShopBuy = async(cart, userID,total,sellerID) =>
    await instance.post("merch/product/buy", {cart, userID,total,sellerID} );

export const getCashUp = async() =>
    await instance.post("merch/cashup");

export const getCashUpBySeller = async() =>
    await instance.post("merch/cashup/byseller");
    
export const submitCashup = async(money,result,userID) =>
    await instance.post("merch/cashup/submit",{money,result,userID});

export const salesByDate = async(sDate,eDate) =>
    await instance.post("merch/report/salesbydate",{sDate,eDate});

export const salesByEmp = async(userID) =>
    await instance.post("merch/report/salesbyemp",{userID});

export const salesByProd = async(prodId) =>
    await instance.post("merch/report/salesbyprod",{prodId}); 
    
export const checkStock = async(minStock) =>
    await instance.post("merch/report/stock", {minStock});